import { graphql, useStaticQuery } from "gatsby"
import { BrandData } from "../components/core/brand"
import { Page } from "./use-navigation-data"

export interface Address {
  place: string;
  street: string;
}

export interface Company {
  title: string;
  email: { value: string; href: string };
  tel: { value: string; href: string };
  address: Address;
}

export interface FooterData {
  brand: BrandData;
  company: Company;
  pages: Page[];
  languages: Language[]
  copyright: string;
}

export interface Language {
  name: string;
  href: string;
}


export const useFooterData: () => FooterData = () => {
  const { site, brand, allSitePage } = useStaticQuery<any>(
    graphql`
        query FooterData {
            site{
                siteMetadata {
                    copyright
                    company{
                        title
                        email
                        tel
                        address {
                            street
                            place
                        }
                    }
                    languages{
                        language
                        default
                        langKey
                    }
                }
            }
            allSitePage(filter: {pluginCreator: {name: {eq: "gatsby-plugin-mdx"}}, context: {frontmatter: {footer: {eq: true}}}}, sort: {fields: context___frontmatter___weight}) {
                nodes {
                    context {
                        langKey
                        slug
                        frontmatter {
                            title
                        }
                    }
                }
            }
            brand:   file(relativePath: {eq: "logo.svg"}) {
                name
                publicURL
            }
        }
    `
  )

  const company = { ...site.siteMetadata.company }

  company.tel = Object.assign({}, { value: company.tel, href: `tel:${company.tel}` })
  company.email = Object.assign({}, { value: company.email, href: `mailto:${company.email}` })

  const pages: Page[] = allSitePage.nodes.map(node => (
    {
      title: node.context.frontmatter.title,
      langKey: node.context.langKey,
      slug: node.context.slug
    } as Page)
  )

  const languages: Language[] = site.siteMetadata.languages.map(lang => ({
    name: lang.language,
    href: lang.default ? "/" : `/${lang.langKey}`
  }))


  return { pages, brand, company, languages, copyright: site.siteMetadata.copyright }

}
